<div class="background">

  <div class="header">
    {{ 'money.actionSelectHeader' | translate }}
  </div>

  <div class="action-buttons-container">
    <div class="desktop-buttons-layout">
      <div class="action-button action-button--add-money" routerLink="/money/deposit" data-cy="deposit-money-action-button">
        <div class="icon-container">
          <svg-icon src="assets/icons/plus-money.svg" [svgStyle]="{ 'width.px':57 }"></svg-icon>
        </div>
        <div class="label">
          {{ 'money.addButtonLabel' | translate }}
        </div>
      </div>

      <div class="additional-consult-button">
        <p>
          {{ 'money.consultDesc' | translate }}
        </p>

        <div
          class="consult-link"
          (click)="modalService.openConsultModal()"
          (keydown.space)="modalService.openConsultModal()"
          (keydown.enter)="modalService.openConsultModal()"
          tabindex="0"
        >
          {{ 'global.iWantConsultation' | translate }}
        </div>
      </div>
    </div>

    <div class="action-button action-button--withdraw-money" routerLink="/money/withdraw" data-cy="withdraw-money-action-button">
      <div class="icon-container">
        <svg-icon src="assets/icons/money-withdraw.svg" [svgStyle]="{ 'width.px':56 }"></svg-icon>
      </div>
      <div class="label">
        {{ 'money.withdrawButtonLabel' | translate }}
      </div>
    </div>

    <div class="action-button action-button--withdraw-money" routerLink="/money/rent" data-cy="rent-money-action-button">
      <div class="icon-container">
        <svg-icon src="assets/icons/money-withdraw.svg" [svgStyle]="{ 'width.px':56 }"></svg-icon>
      </div>
      <div class="label">
        {{ 'money.rentLabel' | translate }}
      </div>
    </div>
  </div>

</div>

<div class="phone-border">
  <div class="phone-corner"></div>
</div>

<libero-filterable-transactions
  [preloaders]="preloaders"
  [transactions]="filteredTransactions"
  [availableInvestments]="availableInvestments"
  [initialInvestmentId]="initialInvestmentId"
  [totalItems]="totalItems"
  (dataUpdated)="updateData($event)"
></libero-filterable-transactions>
